import styled, { css } from 'styled-components'
import { NotinoLabelRegular400, NotinoLabelSmall400, truncate } from '../../styles/helpers'

// eslint-disable-next-line import/prefer-default-export
export const Badge = styled.span<{ $backgroundColor: string; $textColor: string; $size: 'small' | 'default' }>`
	${({ $backgroundColor, $textColor }) => css`
		${truncate};
		max-width: 100%;
		min-width: 0;
		background-color: ${$backgroundColor};
		color: ${$textColor};
		border-radius: 2px;
		display: inline-block;
	`};

	${({ $size }) => {
		switch ($size) {
			case 'small':
				return css`
					${NotinoLabelSmall400};
					padding: 4px 10px;
				`
			case 'default':
			default:
				return css`
					${NotinoLabelRegular400};
					padding: 4px 10px;
				`
		}
	}}
`
